import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-go-to-top',
  templateUrl: './go-to-top.component.html',
  styleUrls: ['./go-to-top.component.scss']
})
export class GoToTopComponent implements OnInit {
  // Go to top
  isShow: boolean;
  isLiftUp: boolean;
  topPosToStartShowing = 100;

  constructor() {}

  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const checkReading =
      document.documentElement.scrollHeight - document.documentElement.scrollTop ===
      document.documentElement.clientHeight;
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
    // if (checkReading === true) {
    //   // this.isLiftUp = true;
    // } else {
    //   // this.isLiftUp = false;
    // }
  }

  // end go tot top

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}
}
